import { useMutation } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { branchUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { deleteSuccessMessage } from "../../Messages/successMessages";

export const useDeleteBranch = () =>
  useMutation({
    mutationFn: (id: number | undefined) => axios.delete<number>(branchUrls.branchWithId(id)),
    onSuccess: async (response: AxiosResponse<number>) => {
      toast.success(deleteSuccessMessage(response.data, "Branch"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
